import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import userContext from "../Context/userContext";
import Cargando from "../Comun/Cargando";

// ══════════════════════════════════════════════════════
//  Ruta que exige haber iniciado sesión
//  - Mientras se comprueba la sesión guardada (recarga de la página) → «Cargando».
//  - Sin sesión → al login, que vuelve aquí después (state.redirectTo, con query y #ancla).
//  La API también lo comprueba (401): esto solo evita enseñar la página.
// ══════════════════════════════════════════════════════

const AuthRoute = ({ user, component }) => {
  const location = useLocation();
  const { cargandoSesion } = useContext(userContext);

  if (cargandoSesion) return <Cargando texto="Comprobando tu sesión…" />;

  if (user) return component;

  const redirectTo = location.pathname + location.search + location.hash;
  return <Navigate to="/login" replace state={{ redirectTo }} />;
};

export default AuthRoute;
